<template >
  <div class="priceManagement-page">
    <div class="all-content-container">
      <div class="screen-all-container">
        <el-tabs v-model="activeName2" @tab-click="handleClick" class="el-tab_top">
          <el-tab-pane label="用户管理" name="second" style="margin-right: 30px">
            <userManagementone></userManagementone>
          </el-tab-pane>
          <el-tab-pane label="角色管理" name="third">
            <roleManagement></roleManagement>
          </el-tab-pane>
          <el-tab-pane label="组织机构" name="fourth">
            <organization></organization>
          </el-tab-pane>
          <el-tab-pane label="系统日志" name="seven">
            <systemLog></systemLog>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="pagination-container">
      <div class="pagination-content-container"></div>
    </div>
  </div>
</template>
<script>
import userManagementone from '@/components/systemManagement/userManagementone'
import roleManagement from '@/components/systemManagement/roleManagement'
import organization from '@/components/systemManagement/organization'
import systemMessage from '@/components/systemManagement/systemMessage'
import systemLog from '@/components/systemManagement/systemLog'
import approvalTemplate from '../approvalManagement/approvalTemplate'
import approvalConfiguration from '../approvalManagement/approvalConfiguration'
import approvalRecord from '../approvalManagement/approvalRecord'
export default {
  name: 'userManagement',
  components: {
    userManagementone,
    roleManagement,
    organization,
    systemMessage,
    systemLog,
    approvalConfiguration,
    approvalRecord,
    approvalTemplate
  },
  data() {
    return {
      activeName2: 'second'
    }
  },
  created() {
    if (this.$route.query.currentShow != null) {
      this.activeName2 = this.$route.query.currentShow
    }
  },
  methods: {
    handleClick() {}
  }
}
</script>
<style scoped>
@import '../../style/userManagement.scss';
</style>